import * as angular from 'angular';

// This can be moved to the aptitude module once we make it a little more generic
// The tableHeader element we create needs to take some of the attributes from the tableBody table but not all
// ie, it should probably take the class attribute from the tableBody table but not the ng-controller attribute

interface DirectiveAttributes extends ng.IAttributes {
  totalHeight: number;
}

interface IWindowMonitor {
  onResize(hook: any): void;
  onHeightResize(hook: any): void;
  onWidthResize(hook: any): void;
}

export default function ScrollableTableBodyDirective(
  WindowMonitor: IWindowMonitor
): ng.IDirective {
  'ngInject';

  return {
    restrict: 'EA',
    replace: false,
    link: function (scope, elem, attrs: DirectiveAttributes) {
      elem.css({ 'overflow-y': 'auto', height: attrs.totalHeight });

      // since overflow is auto, will watch till scrollbars are necessary and then make the table scrollable
      var scrollbarWatcher = scope.$watch(
        function () {
          return elem[0].scrollHeight - elem[0].clientHeight;
        },
        function (overflowPx) {
          if (overflowPx > 0) {
            addScrolling();
          }
        }
      );

      function addScrolling() {
        var thead = elem.find('thead');
        var tableBody = elem.find('table');

        tableBody.addClass('tableBody');

        var tableHeader = angular
          .element(
            '<table class="table tableHeader" style="margin-bottom: 0;"></table>'
          )
          .append(thead); // position: absolute;
        tableBody.before(tableHeader);

        tableBody.wrap(
          '<div style="overflow-y: scroll;" class="scroll-container"></div>'
        );

        elem
          .find('.scroll-container')
          .height(attrs.totalHeight - tableHeader.height());
        tableHeader.width(tableBody.width());

        elem.css('overflow-y', 'visible');

        WindowMonitor.onWidthResize(function () {
          // we need to keep the widths in sync
          tableHeader.width(tableBody.width());
        });

        scrollbarWatcher();
      }
    }
  };
}
